import { isDesktop } from './helpers';

const $ = window.jQuery;

let open = false;
let transforming = false;
const skipLink = $( '#skip-link' );
const mobileNav = $( '#site-navigation-mobile' );
const toggle = $( 'button#menu-toggle' );
const navIcon = $( '.nav-icon' );
const desktopToggle = $( '.site-header #menu-toggle' );
const mobileToggle = $( '#site-navigation-mobile #menu-toggle' );
const mobileNavItems = $( '.main-navigation--mobile #menu-toggle, .main-navigation--mobile a' );
const mobileNavLastItem = mobileNavItems.eq( mobileNavItems.length - 1 );
const page = $( '#page' );

// Menu toggle click.
toggle.click( function() {
	if ( open ) {
		closePanel();
		return;
	}
	openPanel();
	return;
} );

$( '.sr-menu-close' ).click(function() {
	closePanel();
});

// On last focusable nav item, tab will focus to the close button in the menu.
mobileNavLastItem.keydown( function( event ) {
	if ( isDesktop() ) {
		return;
	}

	if ( event.key === 'Tab' && ! event.shiftKey ) {
		event.preventDefault();
		mobileToggle.focus();
	}
});

// Shift Tab on Menu button goes to last item in nav
mobileToggle.keydown( function( event ) {
	if ( isDesktop() ) {
		return;
	}

	if ( event.shiftKey && event.keyCode === 9 ) {
		event.preventDefault();
		mobileNavLastItem.focus();
	}
});

// If mobile nav is open, tab on skip link goes to mobile toggle
skipLink.focusin( function( event ) {
	if ( isDesktop() ) {
		return;
	}

	if ( open ) {
		event.preventDefault();
		mobileToggle.focus();
	}
});



// Listen for escape key click.
document.addEventListener( 'keyup', function( event ) {
	if ( isDesktop() ) {
		return;
	}

	if ( event.keyCode === 27 ) {
		closePanel();
	}
});

// Desktop closes mobile nav.
$( window ).resize( handleResize );
$( document ).ready( handleResize );

function handleResize() {
	if ( isDesktop() ) {
		navIcon.removeClass( 'open' )
		closePanel(false);
	}
}

//
// Open the mobile panel.
//
function openPanel() {
	if ( transforming ) {
		return;
	}
	transforming = true;
	open = true;

	toggle.attr( 'aria-expanded','true' );
	page.attr( 'aria-hidden', 'true' )
	mobileNav.attr( 'aria-hidden','false' );
	navIcon.addClass( 'open' );
	mobileNav.removeClass( 'closed' );
	toggle.addClass( 'open' );
	mobileNav.css( {
		'willChange': 'transform',
		'transition' : 'transform 600ms ease-in-out',
	} );
	window.requestAnimationFrame( () => {
		mobileNav.addClass( 'open' );
		$( 'body' ).css( 'overflow', 'hidden' );
		window.setTimeout( () => {
			$( '.mobile-panel-inner li a' ).eq(0).focus();
			mobileNav.css( {
				'willChange': '',
				'transition' : '',
			} );
			transforming = false;
		}, 600 );
	} );
}

//
// Close the mobile panel.
//
function closePanel(haveFocus = true) {
	if ( transforming ) {
		return;
	}
	transforming = true;
	open = false;

	toggle.attr( 'aria-expanded','false' );
	page.attr( 'aria-hidden', 'false' )
	mobileNav.attr( 'aria-hidden','true' );
	desktopToggle.removeClass( 'open' );
	navIcon.removeClass( 'open' );
	mobileNav.css( {
		'willChange': 'transform',
		'transition' : 'transform 600ms ease-in-out',
	} );
	window.requestAnimationFrame( () => {
		mobileNav.removeClass( 'open' );
		$( 'body' ).css( 'overflow', '' );
		window.setTimeout( () => {
			mobileNav.css( {
				'willChange': '',
				'transition' : '',
			} );
			transforming = false;
		}, 600 );
		window.setTimeout( () => {
			mobileNav.addClass( 'closed' );
			if(haveFocus){
				desktopToggle.focus();
			}
		}, 602);
	} );
}
